import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
  ko: {
    // ...require('@/locales/ko/global.json').data,
  },
  en: {
    // ...require('@/locales/en/global.json').data,
  },
}

export const checkDefaultLanguage = () => {
  let matched = null
  const languages = Object.getOwnPropertyNames(messages)
  languages.forEach(lang => {
    if (lang === (window.localStorage.lang || navigator.language || navigator.userLanguage)) {
      matched = lang
    }
  })
  if (!matched) {
    languages.forEach(lang => {
      const languagePartials = (window.localStorage.lang || navigator.language || navigator.userLanguage).split('-')[0]
      if (lang === languagePartials) {
        matched = lang
      }
    })
  }

  return matched
}

export default new VueI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'ko',
  locale: checkDefaultLanguage() || 'ko',
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ko',
  fallbackLocale: checkDefaultLanguage() || 'ko',
  messages,
  silentTranslationWarn: true
})
